import { Box, Button } from '@mui/material';
import { useCallback } from 'react';
import { GenericDialog } from 'src/shared/components/organisms/genericDialog';
import { DataGrid, GridCellParams, GridColDef } from '@mui/x-data-grid';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { useTranslation } from 'react-i18next';
import { AmountWithCurrency } from 'src/shared/components/atoms/amountWithCurrency';
import { InvoicePayment } from '../models/paymentGroupedByDate';

type PaymentTransactionModalProps = {
  modalOpen: boolean;
  invoicePayments: InvoicePayment[];
  onSave: () => void;
  onClose: () => void;
};

export const PaymentTransactionModal = (props: PaymentTransactionModalProps) => {
  const { modalOpen, invoicePayments, onSave, onClose } = props;
  const { t } = useTranslation(['invoice']);

  ConsoleHelper.log('invoicePayments', invoicePayments);

  const onHandleSave = useCallback(() => {
    onSave();
  }, [onSave]);

  const onHandleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  const columns: GridColDef[] = [
    {
      field: 'date',
      headerName: t('invoice:date'),
      flex: 0.75,
      renderCell: (params: GridCellParams) => {
        return params.row.date;
      },
    },
    {
      field: 'source',
      headerName: t('invoice:paymentHeader'),
      flex: 0.8,
      renderCell: (params: GridCellParams) => {
        return params.row.source;
      },
    },
    {
      field: 'invoiceMissionName',
      headerName: t('invoice:invoiceMission'),
      flex: 2,
      renderCell: (params: GridCellParams) => {
        return params.row.invoiceMissionName;
      },
    },
    {
      field: 'invoice.ocr',
      headerName: t('invoice:OCR'),
      flex: 1,
      renderCell: (params: GridCellParams) => {
        return params.row.invoice.ocr;
      },
    },
    {
      field: 'amount',
      headerName: t('invoice:amount'),
      flex: 1,
      renderCell: (params: GridCellParams) => {
        return <AmountWithCurrency amount={params.row.amount} />;
      },
    },
    {
      field: 'invoice.comment',
      headerName: t('invoice:transactionPage.comment'),
      flex: 1,
      renderCell: (params: GridCellParams) => {
        return params.row.invoice.comment;
      },
    },
  ];

  return (
    <GenericDialog
      open={modalOpen}
      padding={0}
      maxWidth='lg'
      dialogTitle={t('invoice:incomingBankPayment.editModalHeader')}
      onClose={onHandleClose}
      onSave={onHandleSave}
      dialogContent={
        <Box sx={{ p: 2, height: '30rem' }}>
          <DataGrid density='compact' getRowId={(row) => row.invoicePayment_id} columns={columns} rows={invoicePayments} />
        </Box>
      }
      dialogActions={
        <Button variant='outlined' disableElevation onClick={onHandleClose}>
          {t('common:button.close')}
        </Button>
      }
    />
  );
};
